// extracted by css-extract-rspack-plugin
export default {"buttonInner":"button-inner--GXoH9TW1I00Pob2n","buttonInnerMenu":"button-inner_menu--b2gkyQjwmW4enfEt"};